import React from "react";
import Margin from "canvas-core-react/lib/Margin";
import TextBody from "canvas-core-react/lib/TextBody";
import Modal from "../modal/modal";
import {useAppContext} from "../../context/AppContext";

const ErrorBody = () => (
    <Margin lg={18} md={18} xs={18} sm={18} side={"top"}>
        <TextBody component={"span"} type={"2"}>
            {
                "En este momento nuestro servicio no está disponible o te encuentras sin conexión. Inténtalo más tarde."
            }
        </TextBody>
    </Margin>
);

const ModalGeneralError = ({
                               retryCallBack = () => {
                               }
                           }) => {
    const {changeItem} = useAppContext();
    const retry = () => {
        changeItem({error: false, ErrorComponent: null});
        setTimeout(retryCallBack, 200);
    };
    return (
        <Modal
            title={"Lo sentimos"}
            Description={ErrorBody}
            buttonLabel={"Reintentar"}
            action={retry}
        />
    );
};

export default ModalGeneralError;
